import * as React from 'react';
import * as Config from 'ofxSettings';
import { isEmptyOrWhiteSpace } from 'libs/string';

interface IOptions {
    className?: string;
    handleOnClick?: (routeName?: string) => void;
    routeParams?: string;
}

interface IComponentProps {
    url?: string;
    routeName?: string;
    text: string;
    options?: IOptions;
    target?: string;
}

class Navigate extends React.Component<IComponentProps, IOptions> {
    static displayName = 'Navigate';

    constructor(props: IComponentProps) {
        super(props);

        this.onClick = this.onClick.bind(this);

        const { options } = this.props;
        this.state = { ...options };
    }

    onClick() {
        if (this.state.handleOnClick !== undefined) {
            this.state.handleOnClick(this.props.routeName);
        }
    }

    componentWillReceiveProps(nextProps: IComponentProps) {
        if (this.props.options !== nextProps.options) {
            this.setState({ ...nextProps.options });
        }
    }

    render() {
        const { url, routeName, text, target } = this.props;
        let route = url;

        if (isEmptyOrWhiteSpace(route) && routeName) {
            route = this.state.routeParams
                ? `${Config.routes[routeName]}?${this.state.routeParams}`
                : `${Config.routes[routeName]}`;
        }

        return (
            <a href={route} onClick={this.onClick} className={this.state.className} target={target}>
                {text}
            </a>
        );
    }
}

export default Navigate;
